import { INITIAL_FORMULAIRE_RECHERCHE } from '../../resultats-recherche/types/formulaireRechercheModel'
import { champsMenuRechercheEnum, toutesLesLocalisations } from '../../resultats-recherche/enums/champsMenuRecherche'

export const DEFAULT_OFFER_FILTERS = `?filtres=${
	JSON.stringify({
		...INITIAL_FORMULAIRE_RECHERCHE,
		[champsMenuRechercheEnum.location]: toutesLesLocalisations
	})
}`